import React from 'react';
import { View, ScrollView } from 'react-native';
import { globalStyles } from '../../styles/globalStyles';
import { FormField } from './FormField';

export function VenueDetailsForm({ formFields, onFieldChange }) {
  return (
    <ScrollView 
      horizontal 
      showsHorizontalScrollIndicator={false}
      contentContainerStyle={globalStyles.formContainer}
    >
      {formFields.map((section, index) => (
        <View key={index} style={globalStyles.formSection}>
          {section.fields.map((field, fieldIndex) => (
            <FormField
              key={fieldIndex}
              label={field.label}
              value={field.value}
              placeholder={field.placeholder}
              type={field.type}
              onChange={(value) => onFieldChange(section.section, field.label, value)}
            />
          ))}
        </View>
      ))}
    </ScrollView>
  );
} 